function ChartModel(chartData) {
  this.type = chartData.type == null ? 'line' : chartData.type;
  this.data = {
    labels: formattedData(
      chartData.map(function (x) {
        return x.semana_dia_mes;
      }),
      chartData.map(function (x) {
        return x.tipo_vista;
      }),
      chartData.map(function (x) {
        return x.anyo;
      })
    ),
    datasets: Object.keys(aplicacionesDiccionario).map(function (x) {
      return new Dataset(chartData, x);
    }),
  };
  this.options = {
    scales: {
      x: {
        ticks: {
          font: {
            size: 14,
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 14,
          },
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
          },
        },
        position: 'bottom',
        backgroundColor: 'rgba(0, 0, 0, 0.0)',
      },
      tooltip: {
        mode: 'nearest',
        intersect: false,
        bodyFontSize: 40,
        callbacks: {
          label: function (data) {
            var label = 'Numero de consultas realizadas: ' + data.formattedValue || '';
            return label;
          },
        },
      },
    },
  };
}

function formattedData(data, type, anyo) {
  return data.map(function (num) {
    var numString = num.toString();
    if (numString.length === 8) {
      var dataformatString =
        numString.substring(0, 4) + '-' + numString.substring(4, 6) + '-' + numString.substring(6, 8);

      // Crear un objeto Date a partir de la cadena de fecha
      var fecha = new Date(dataformatString);

      // Obtener el día, el mes y el año de la fecha
      var dia = fecha.getDate();
      var mes = fecha.toLocaleString('default', { month: 'short' });

      // Crear la cadena de fecha formateada
      var fechaFormateada = dia + ' de ' + mes;

      return fechaFormateada;
    }
    if (type[0] === 'SEMANAL') {
      var fechasSemanales = anyo.map(function (x) {
        var date = new Date(x, 0, 1 + (num - 1) * 7);
        var startDate = new Date(date.setDate(date.getDate() - date.getDay()));
        var endDate = new Date(date.setDate(date.getDate() + 6));

        var startMonth = ('0' + (startDate.getMonth() + 1)).slice(-2); // Agrega un cero adelante si es necesario
        var startDay = ('0' + startDate.getDate()).slice(-2); // Agrega un cero adelante si es necesario
        var endMonth = ('0' + (endDate.getMonth() + 1)).slice(-2); // Agrega un cero adelante si es necesario
        var endDay = ('0' + endDate.getDate()).slice(-2); // Agrega un cero adelante si es necesario

        var startYear = startDate.getFullYear();
        var endYear = endDate.getFullYear();

        return startDay + '/' + startMonth + ' al ' + endDay + '/' + endMonth + ' ' + startYear;
      });

      return Array.from(new Set(fechasSemanales));
    }
    if (type[0] === 'MENSUAL') {
      var mesesCortos = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      return mesesCortos[num - 1];
    }
    if (type[0] === 'ANUAL') {
      return Array.from(new Set(anyo));
    }
  });
}

var aplicacionesDiccionario = Object.freeze({
  SPD: {
    siglas: 'SPD',
    nombre: 'Servicio Proveedor de Datos',
    propiedad: 'total_spd',
    color: '#4d1f2e',
  },
  CARP: {
    siglas: 'CARP',
    nombre: 'Carpeta Ciudadana',
    propiedad: 'total_carp',
    color: '#aa3c2b',
  },
  CARNET: {
    siglas: 'CARNET',
    nombre: 'Aplicacion de carnets del Gobierno de Aragon',
    propiedad: 'total_carnet',
    color: '#739ba5',
  },
  XFILES: {
    siglas: 'XFILES',
    nombre: 'Aplicación para gestor de expedientes',
    propiedad: 'total_xfiles',
    color: '#ed6c02',
  },
  SOPORTE: {
    siglas: 'SOPORTE',
    nombre: 'Aplicación Soporte HAL',
    propiedad: 'total_hal_soporte',
    color: '#bc8a01',
  },
  SINAPP: {
    siglas: 'SINAPP',
    nombre: 'Solicitudes realizadas sin aplicaciones',
    propiedad: 'total_sin_app',
    color: '#013c53',
  },
});

function Dataset(dataSet, type) {
  this.label = aplicacionesDiccionario[type].nombre;
  this.data = dataSet.map(function (x) {
    return x[aplicacionesDiccionario[type].propiedad];
  });
  this.fill = false;
  this.borderColor = aplicacionesDiccionario[type].color;
  this.backgroundColor = aplicacionesDiccionario[type].color;
  this.tension = 0.3;
}

module.exports = { ChartModel: ChartModel };
